import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import PropTypes from 'prop-types'
import Routes from 'src/routes'

import {
  selectCompanyThemePrimaryColor,
  selectCompanyTheme,
} from 'src/store/selectors/customerProfile'
import { selectToasts } from 'src/store/selectors/toasts'
import { setThemeCssColorVar } from 'src/hooks/theme'

// State
import { useThemeContext, ThemeProvider } from 'src/context/theme'

// Components
import Notification from 'src/Components/shared/Notification'
import { LOADING_THEME } from 'src/constants/theme'
import BombBomb from './BombBomb'
import DisclaimerModal from './DisclaimerModal'
import ErrorModal from './ErrorModal'
import { Toasts } from 'src/Components/shared/Toasts'

const Homebot = ({ error }) => {
  const { theme, setTheme } = useThemeContext()

  const companyThemeFromApiResponse = useSelector(selectCompanyTheme)
  const themePrimaryColor = useSelector(selectCompanyThemePrimaryColor)
  const themeTilCompanyResponse = localStorage.getItem(LOADING_THEME)
  const toasts = useSelector(selectToasts)

  // Needed for the PURL preview
  // Initially load the previous loaded theme
  useEffect(() => {
    setTheme(themeTilCompanyResponse)
  }, [setTheme, themeTilCompanyResponse])

  useEffect(() => {
    // Set company theme ONY if different from theme set in local storage - prevents re-renders
    if (companyThemeFromApiResponse && companyThemeFromApiResponse !== theme) {
      setTheme(companyThemeFromApiResponse)
      localStorage.setItem('LOADING_THEME', companyThemeFromApiResponse)
    }
  }, [setTheme, companyThemeFromApiResponse, theme])

  useEffect(() => {
    if (themePrimaryColor) {
      setThemeCssColorVar('brand-primary-custom', themePrimaryColor)
    }
  }, [themePrimaryColor])

  return (
    <div data-theme={theme} id='themeContainer'>
      <Notification />
      <Routes />
      <BombBomb />
      <DisclaimerModal />
      <Toasts toasts={toasts} />
      {error && <ErrorModal />}
    </div>
  )
}

const App = ({ error }) => (
  <ThemeProvider>
    <Homebot error={error} />
  </ThemeProvider>
)

App.propTypes = {
  error: PropTypes.bool,
}

Homebot.propTypes = {
  error: PropTypes.bool,
}

export default App
